<template>
  <div class="guangfu-tongyi">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>发电统计</span>
        </div>
        <div class="btns">
          <el-button type="primary" class="last-el-button">导出</el-button>
        </div>
      </div>
      <div class="search-input-btn" style="width:100%">
        <div class="input-small ">
          <span>时间：</span>
          <el-date-picker v-model="value2" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <el-button type="primary" plain class="search-btn">查询</el-button>
      </div>
      <div class="myteble">
        <el-table :data="tableData" stripe style="width: 100%" :height="heights">
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="测量点"> </el-table-column>
          <el-table-column prop="timer" label="6-20"> </el-table-column>
          <el-table-column prop="timer2" label="6-21"> </el-table-column>
          <el-table-column prop="timer3" label="6-22"> </el-table-column>
          <el-table-column prop="timer4" label="6-23"> </el-table-column>
          <el-table-column prop="timer5" label="6-24"> </el-table-column>
          <el-table-column prop="timer6" label="6-25"> </el-table-column>
          <el-table-column prop="timer7" label="6-26"> </el-table-column>
          <el-table-column prop="timer8" label="6-27"> </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'WedoWebEleEfficiency',

    data () {
      return {
        tableData: [
          {
            'name': "珠海维度",
            'timer': "1816.0",
            'timer2': "1833.0",
            'timer3': "1928.0",
            'timer4': "1081.0",
            'timer5': "684.0",
            'timer6': "532.0",
            'timer7': "2851.0",
            'timer8': "652.0",
          },
          {
            'name': "#1逆变器",
            'timer': "116.0",
            'timer2': "118.0",
            'timer3': "130.0",
            'timer4': "110.0",
            'timer5': "70.0",
            'timer6': "82.0",
            'timer7': "72.0",
            'timer8': "61.0",
          },
          {
            'name': "#2逆变器",
            'timer': "130.0",
            'timer2': "65.0",
            'timer3': "68.0",
            'timer4': "125.0",
            'timer5': "33.0",
            'timer6': "44.0",
            'timer7': "58.0",
            'timer8': "70.0",
          },
          {
            'name': "#3逆变器",
            'timer': "140.5",
            'timer2': "352.0",
            'timer3': "120.0",
            'timer4': "58.0",
            'timer5': "98.0",
            'timer6': "75.0",
            'timer7': "72.0",
            'timer8': "62.0",
          },
          {
            'name': "#4逆变器",
            'timer': "151.0",
            'timer2': "125.0",
            'timer3': "101.28",
            'timer4': "75.0",
            'timer5': "135.82",
            'timer6': "28.0",
            'timer7': "53.0",
            'timer8': "92.0",
          },
          {
            'name': "#5逆变器",
            'timer': "250.0",
            'timer2': "135.0",
            'timer3': "30.0",
            'timer4': "52.0",
            'timer5': "50.0",
            'timer6': "25.0",
            'timer7': "16.0",
            'timer8': "62.0",
          },
          {
            'name': "#6逆变器",
            'timer': "213.0",
            'timer2': "167.0",
            'timer3': "200.0",
            'timer4': "130.0",
            'timer5': "26.21",
            'timer6': "97.0",
            'timer7': "45.0",
            'timer8': "25.0",
          },
          {
            'name': "#7逆变器",
            'timer': "150.0",
            'timer2': "302.0",
            'timer3': "135.39",
            'timer4': "0.00",
            'timer5': "97.21",
            'timer6': "45.0",
            'timer7': "47.0",
            'timer8': "95.0",
          },

        ],
        value2: [1687190400000,1687795200000],
        options: [{
          value: 'date',
          label: '日'
        },{
          value: 'month',
          label: '月'
        },{
          value: 'year',
          label: '年'
        }],
        value: 'date',
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
      };
    },

    mounted () {

    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .guangfu-tongyi {}
</style>